const styles = {
  hideNavOnEnd: (hide) => ({
    '.swiper-button-disabled': {
      display: hide ? 'none' : 'flex',
    },
  }),
}

export default styles
